import { render, staticRenderFns } from "./ServicioNoConforme.vue?vue&type=template&id=b0857adc&"
import script from "./ServicioNoConforme.vue?vue&type=script&lang=js&"
export * from "./ServicioNoConforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports